import React, { useCallback, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { updateCollection } from "../../services/firebase";
import { FIREBASE_COLLECTION_DOC_KEY, FIREBASE_COLLECTION_KEY, ROUTE_PATHS } from "../../constants";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAddUpdateGameInitialState,
  getCentralMatkaNumber,
  getCurrentDayGames,
  getSelectedParam,
  isEmpty,
  onTimeChange,
  updateGameAtCurrentIndex,
  upsertTodayGame,
  withGameUI,
} from "../../util";

import "./css/style.min.css";
import "./css/matkaplay.css";
import "../common.css";
const AddGameScreen = ({ 
  data, 
  gamesList,
  gamesTimeTableList,
  guessingTableList,
  fatafatTableList,
  onGamesSaved,
}) => {
  const navigate = useNavigate();
  const params = useParams();

  const selectedGameIndex = getSelectedParam(params);

  const [
    { gameName, startTime, endTime, lhsValue, rhsValue, createdTime },
    setState,
  ] = useState(
    getAddUpdateGameInitialState(
      getCurrentDayGames(gamesList),
      selectedGameIndex
    )
  );
  const [selectedGameTimeIndex, setSelectedGameTimeIndex] = useState(
    parseInt(selectedGameIndex ?? 0) ?? 0
  );
  const [isSaving, setIsSaving] = useState(false);

  const sortedGameTimeTableList =
    gamesList?.length > 0 ? gamesList : data?.gamesTimeTable || [];
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    setState((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  // const createGameAPICall = (body) => {
  //   APIService.post(API_CONFIGS.CREATE_GAME.URL, body)
  // }
  // const updateGameAPICall = (body) => {
  //   APIService.post(API_CONFIGS.UPDATE_GAME.URL, body)
  // }

  const persistGames = (gameTypes) => {
    setIsSaving(true);
    const nextDoc = {
      ...data,
      gameTypes,
    };
    updateCollection(FIREBASE_COLLECTION_KEY, FIREBASE_COLLECTION_DOC_KEY, {
      gameTypes,
    })
      .then(() => {
        if (onGamesSaved) {
          onGamesSaved(nextDoc);
        }
        navigate(ROUTE_PATHS.HOME);
      })
      .catch((error) => {
        console.error("firebase game save failed", error);
        setIsSaving(false);
        alert("Could not save the game in Firebase.");
      });
  };

  const handleAddGameSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (isSaving) {
        return;
      }

      if (selectedGameTimeIndex === null || !sortedGameTimeTableList[selectedGameTimeIndex]) {
        alert("Enter all the details.");
        return;
      }

      const selectedGame = withGameUI(sortedGameTimeTableList[selectedGameTimeIndex]);
      const digits = {
        lhsValue: !isEmpty(lhsValue) ? lhsValue : "***",
        rhsValue: !isEmpty(rhsValue) ? rhsValue : "***",
        winnerValue: getCentralMatkaNumber(
          parseInt(lhsValue, 10),
          parseInt(rhsValue, 10)
        ),
      };

      if (selectedGameIndex === null) {
        const gameObject = {
          ...selectedGame,
          ...digits,
          name: selectedGame.gamesTimeTableUI.name,
          startTime: selectedGame.gamesTimeTableUI.startTime,
          endTime: selectedGame.gamesTimeTableUI.endTime,
          gamesTimeTableId: selectedGame.gamesTimeTableUI.gamesTimeTableId,
          createdTime: createdTime || new Date().toISOString(),
        };
        persistGames(upsertTodayGame(data.gameTypes || [], gameObject));
        return;
      }

      const foundObj = gamesList[selectedGameIndex];
      const gameObjectUpdated = {
        ...foundObj,
        ...digits,
        guessGameTypeId: foundObj?.guessGameTypeId,
        createdTime: foundObj?.createdTime || createdTime,
        gamesTimeTableId: foundObj?.gamesTimeTableUI?.gamesTimeTableId,
      };
      persistGames(
        updateGameAtCurrentIndex(
          data.gameTypes || [],
          selectedGameIndex,
          gameObjectUpdated
        )
      );
    },
    [
      data,
      gamesList,
      lhsValue,
      rhsValue,
      createdTime,
      isSaving,
      onGamesSaved,
      selectedGameIndex,
      selectedGameTimeIndex,
      sortedGameTimeTableList,
    ]
  );
  return (
    <div className="login">
      <div className="container round_border_card">
        <h2 className="text-center">
          {selectedGameIndex === null ? "Add New Game" : "Update Game Detail"}
        </h2>
        <br />
        <form
          name="adminAddGame"
          validate
          onSubmit={handleAddGameSubmit}
          className="loginForm"
        >
          <div className="input-group">
            {sortedGameTimeTableList.map((gameType, index) => {
              const gameUi = withGameUI(gameType).gamesTimeTableUI;
              const listItem = `${onTimeChange(gameUi.startTime)} - ${onTimeChange(
                gameUi.endTime
              )} ${gameUi.name}`;
              return (
                <tbody key={`${gameUi.name}_${index}`}>
                  <tr>
                    <td>
                      <input
                        type="radio"
                        id="selectedGameTime"
                        name="selectedGameTime"
                        // className="mb-0"
                        required
                        disabled={
                          selectedGameIndex !== null
                            ? selectedGameTimeIndex !== index
                            : false
                        }
                        value={listItem}
                        checked={selectedGameTimeIndex === index}
                        onChange={(e) => {
                          console.log('onchange bullet', {e: e.target.value, index})
                          setSelectedGameTimeIndex(index)
                        }}
                      />
                      <span className="font-weight-bold ml-3">{listItem}</span>
                    </td>
                  </tr>
                </tbody>
              );
            })}
            {/* <label className="label">Game Name</label>
              <input
                type="text"
                id="gameName"
                name="gameName"
                className="form-control"
                placeholder="Enter the Game Name*"
                required
                onChange={handleChange}
                value={gameName}
              /> */}
            <span className="error-message"></span>
          </div>
          {/* <div className="input-group mt-2">
              <label className="label">Start Time</label>
              <input
                type="time"
                id="startTime"
                name="startTime"
                className="form-control"
                placeholder="Enter the start time*"
                required
                onChange={handleChange}
                value={startTime}
              />
              <span className="error-message"></span>
            </div> */}
          {/* <div className="input-group mt-2">
              <label className="label">End Time</label>
              <input
                type="time"
                id="endTime"
                name="endTime"
                className="form-control"
                placeholder="Enter the end time*"
                required
                onChange={handleChange}
                value={endTime}
              />
              <span className="error-message"></span>
            </div> */}
          <div className="input-group mt-2">
            <label className="label">First Game Digits</label>
            <input
              type="number"
              id="lhsValue"
              name="lhsValue"
              className="form-control"
              placeholder="Enter the first game digits*"
              maxLength={3}
              minLength={3}
              onChange={handleChange}
              value={lhsValue}
              disabled={isSaving}
            />
            <span className="error-message"></span>
          </div>
          <div className="input-group mt-2">
            <label className="label">Second Game Digits</label>
            <input
              type="number"
              id="rhsValue"
              name="rhsValue"
              className="form-control"
              placeholder="Enter the second game digits*"
              maxLength={3}
              minLength={3}
              onChange={handleChange}
              value={rhsValue}
              disabled={isSaving}
            />
            <span className="error-message"></span>
          </div>
          <br />
          <button
            className="button btn btn-custom btn-lg"
            type="submit"
            disabled={isSaving}
            aria-busy={isSaving}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              opacity: isSaving ? 0.65 : 1,
              cursor: isSaving ? "not-allowed" : "pointer",
            }}
          >
            {isSaving && <FontAwesomeIcon icon={faSpinner} spin />}
            {isSaving ? "Saving..." : selectedGameIndex === null ? "Add" : "Update"}
          </button>
          <button
            className="button btn btn-custom btn-lg mt-2 ml-0"
            type="button"
            disabled={isSaving}
            onClick={() => navigate(ROUTE_PATHS.HOME)}
            style={{ marginTop: "10px" }}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddGameScreen;
